@let invalid_layout = loading() || !unit() ? 'd-flex justify-content-center align-items-center' : '';
<div [class]="invalid_layout" class="unit-details">
    @if (loading()) {
        <app-spin-kit-wave style="--sk-size: 20px;" />
    
    } @else if (unit(); as currentUnit) {
    
        <ul appListGroup class="list-unstyled mb-0">
    
            <li appListGroupItem>
                <span class="fw-semibold me-1">{{ TRANSLATE_KEY_MAP.DETAILS.NAME() | translate }}:</span>
                <app-fallback [value]="currentUnit.name" />
            </li>
    
            <li appListGroupItem>
                <span class="fw-semibold me-1">{{ TRANSLATE_KEY_MAP.DETAILS.TYPE() | translate }}:</span>
                <app-fallback [value]="currentUnit.type?.name" />
            </li>
    
            <li appListGroupItem>
                <span class="fw-semibold me-1">{{ TRANSLATE_KEY_MAP.DETAILS.LEVEL() | translate }}:</span>
                <app-fallback [value]="currentUnit.level" />
            </li>
    
            <li appListGroupItem>
                <span class="fw-semibold me-1">{{ TRANSLATE_KEY_MAP.DETAILS.CREATED_ON() | translate }}:</span>
                <app-fallback [value]="currentUnit.createdOn">
                    <ng-template appTemplate="valueTemplate">
                        {{ currentUnit.createdOn | date: 'dd-MM-yyyy' }}
                    </ng-template>
                </app-fallback>
            </li>
    
            <li appListGroupItem>
                <span class="fw-semibold me-1">{{ TRANSLATE_KEY_MAP.DETAILS.DESCRIPTION() | translate }}:</span>
                <app-fallback [value]="currentUnit.description">
                    <ng-template appTemplate="valueTemplate">
                        <p class="mb-0" [innerHTML]="currentUnit.description"></p>
                    </ng-template>
                </app-fallback>
            </li>
    
            <li appListGroupItem class="py-5">
                @if (mapPosition(); as position) {
                    <google-map
                        width="100%"
                        height="300px"
                        [zoom]="15"
                        [center]="position"
                        [options]="mapOptions"
                    >
                        <map-marker
                            [position]="position"
                            [options]="{ draggable: false }"
                        />
                    </google-map>
                }
            </li>
    
        </ul>
    
    } @else if (showEmptyPlaceholder()) {
    
        <div class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
            <i class="ti ti-building-community fs-1 mb-2"></i>
            <p>{{ 'UNIT_MANAGEMENT.GENERAL.SELECT_ITEM' | translate }}</p>
        </div>
    
    }
</div>
